import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import { Input, Grid, Button } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class MaxWidthDialog extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
    gstin: 0
  };

  handleClickOpen = () => {

    if (this.props.type == 'add') {
      this.setState({ open: true });
    }
    else {
      let name, gst, mrp, dnp, mrpwithouttax, dnpwithouttax;
      this.props.data.map((x) => {
        if (this.props.id == x.id) {
          name = x.name;
          gst = x.gst;
          mrp = x.mrp;
          dnp = x.dnp;
          mrpwithouttax = x.mrp;
          dnpwithouttax = x.dnp;
          let taxmrp = (mrp*gst)/100;
          let taxdnp = (dnp*gst)/100;
          mrp = Number(mrp) + Number(taxmrp);
          dnp = Number(dnp) + Number(taxdnp);
          mrp = Math.round(mrp);
          dnp = Math.round(dnp);
        }
      })
      this.setState({ name: name, gstin: gst, dnp: dnp, mrp: mrp, open: true, dnpWithoutTax: dnpwithouttax, mrpWithoutTax: mrpwithouttax })
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleMaxWidthChange = event => {
    this.setState({ maxWidth: event.target.value });
  };

  handleFullWidthChange = event => {
    this.setState({ fullWidth: event.target.checked });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
    let tax = this.state.gstin;
    if (tax < 10) {
      tax = '1.0'+tax;
    }
    else {
      tax = '1.'+tax;
    }
    try {
      tax = Number(tax);
    } catch (e) {
    }
    if (name == 'dnp') {
      let dnpWithoutTax = event.target.value;
      dnpWithoutTax = Number(dnpWithoutTax);
      dnpWithoutTax = Number(dnpWithoutTax/tax).toFixed(2);
      this.setState({ dnpWithoutTax: dnpWithoutTax })
    }
    if (name == 'mrp') {
      let mrpWithoutTax = event.target.value;
      mrpWithoutTax = Number(mrpWithoutTax);
      mrpWithoutTax = Number(mrpWithoutTax/tax).toFixed(2);
      this.setState({ mrpWithoutTax: mrpWithoutTax })
    }
  };

  submit = () => {
    let context = this;
    let name = this.state.name;
    let gstin = this.state.gstin;
    let dnp = this.state.dnpWithoutTax;
    let mrp = this.state.mrpWithoutTax;
    if (name == undefined || name == '' || name == null) {
      alert('Enter Machine Name!!!');
      return;
    }
    if (gstin == undefined || gstin == '' || gstin == null) {
      alert('Enter GSTIN');
      return;
    }
    if (dnp == undefined || dnp == '' || dnp == null) {
      alert('Enter DNP');
      return;
    }
    if (mrp == undefined || mrp == '' || mrp == null) {
      alert('Enter MRP');
      return;
    }
    let data1 = { 'name': name, 'gstin': gstin, 'dnp': dnp, 'mrp': mrp };
    let url = Server() + 'machineinfo/insert.php';
    if (this.props.type == 'edit') {
      data1 = { 'name': name, 'gstin': gstin, 'dnp': dnp, 'mrp': mrp, 'id': this.props.id };
      url = Server() + 'machineinfo/update.php';
    }
    this.setState({ load: true, message: 'Adding Details' });
    $.ajax({
      type: 'POST',
      data: data1,
      url: url,
      success: function(data)
      {
        context.setState({ load: false })
        console.log(data);
        if (data == 1) {
          context.setState({ open: false, name: '', gstin: '', mrp: '', dnp: '' })
          context.props.getMachine(1);
        }
        else {
          alert('Error!!!')
        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });

  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Loading load={this.state.load} message={this.state.message} />
        { (this.props.type == 'add') ?
          (
            <Button primary style={{ display: this.props.machineinfoedit }} onClick={this.handleClickOpen}>
              Add Machine
            </Button>
          ) :
          (
            <div style={{ display: this.props.machineinfoedit }} onClick={this.handleClickOpen}>Edit</div>
          )
        }

        <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">{this.props.title}</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Machine Name<br/>
                <Input value={this.state.name} onChange={this.handleChange('name')} fluid />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                GST<br/>
                <Input value={this.state.gstin} type='number' onChange={this.handleChange('gstin')} fluid  />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                DNP<br/>
                <Input value={this.state.dnp} onChange={this.handleChange('dnp')} fluid  />
                {'Rs. '+this.state.dnpWithoutTax}
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                MRP<br/>
                <Input value={this.state.mrp} onChange={this.handleChange('mrp')} fluid  />
                {'Rs. '+this.state.mrpWithoutTax}
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <Button primary onClick={this.submit}>Submit</Button>
              </Grid.Column>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);
